
















import { Vue, Component, Prop } from 'vue-property-decorator';
import {namespace} from "vuex-class";

import Maps from '@/views/components/Maps/Maps.vue';
import {IHub} from "@/models/StoreModels";

const hubsModule = namespace("hubs");

@Component({
  name: 'ShowOneHub',
  components: {
    Maps,
  },
})
export default class ShowOneHub extends Vue {
  @Prop({ default: -1 })
  private hubId!: number|string;

  @hubsModule.Getter('getHubById')
  private getHubById!: (hubId: string | number) => IHub;

  private loading: boolean = false;

  get hubList(): IHub[] {
    const myHub: IHub = this.getHubById(this.hubId);
    return [myHub];
  }

  private exitMaps() {
    this.$emit("showOneHub:close");
    this.$uiBus.emit("dropup:close");
  }

}
